import { Navbar, Footer } from '@/components/marketing';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <section className="pt-32 pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>
            <p className="text-muted-foreground mb-8">Last updated: December 2024</p>

            <div className="prose prose-gray dark:prose-invert max-w-none">
              <h2 className="text-2xl font-bold mt-8 mb-4">1. Information We Collect</h2>
              <p className="text-muted-foreground mb-4">
                We collect information you provide directly to us, such as when you create an 
                account, make a purchase, or contact us for support. This may include your name, 
                email address, phone number, and business information.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">2. How We Use Your Information</h2>
              <p className="text-muted-foreground mb-4">
                We use the information we collect to provide, maintain, and improve our services, 
                process transactions, send you technical notices and support messages, and respond 
                to your comments and questions.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">3. Information Sharing</h2>
              <p className="text-muted-foreground mb-4">
                We do not sell, trade, or otherwise transfer your personal information to outside 
                parties. This does not include trusted third parties who assist us in operating 
                our website, conducting our business, or servicing you.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">4. Data Security</h2>
              <p className="text-muted-foreground mb-4">
                We implement a variety of security measures to maintain the safety of your 
                personal information. All data is encrypted in transit and at rest using 
                industry-standard encryption protocols.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">5. Your Rights</h2>
              <p className="text-muted-foreground mb-4">
                You have the right to access, correct, or delete your personal information at 
                any time. You can do this through your account settings or by contacting us 
                directly.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">6. Cookies</h2>
              <p className="text-muted-foreground mb-4">
                We use cookies to enhance your experience on our platform. You can choose to 
                disable cookies through your browser settings, though this may limit some 
                functionality.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">7. Contact Us</h2>
              <p className="text-muted-foreground mb-4">
                If you have any questions about this Privacy Policy, please contact us at 
                privacy@VirtualSpark info tech.com
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
